import { useEffect, useState } from "react";
import { useGetPatientSyncStatusQuery } from "../service/patientSync.service";
import { useAppSelector } from "./redux-hooks";

/** A pull is a real EHR login, so nothing changes on a sub-minute timescale. */
const POLL_MS = 30000;

/** Whether this clinician's patient list is still being fetched from their EHR. */
export default function usePatientSync() {
  const isRpaGroup = Boolean(useAppSelector((state) => state.auth.userInfo.group_rpa_enabled));
  const [settled, setSettled] = useState(false);
  const { data } = useGetPatientSyncStatusQuery(undefined, {
    skip: !isRpaGroup,
    pollingInterval: settled ? 0 : POLL_MS,
  });

  useEffect(() => {
    if (data && data.state !== "syncing") setSettled(true);
  }, [data]);

  return { isSyncing: data?.state === "syncing", since: data?.since ?? null };
}
